import React from 'react';
import ContactForm from '../../components/contacts/ContactForm';

const ContactCreatePage: React.FC = () => {
  return (
    <div className="mx-auto max-w-5xl px-4 py-3">
      <ContactForm mode="create" />
    </div>
  );
};

export default ContactCreatePage;